var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHealthcareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3477_17734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2345 33.75H1.125C0.504 33.75 0 33.246 0 32.625C0 32.004 0.504 31.5 1.125 31.5H13.2345C13.6643 31.5 14.049 31.2615 14.2402 30.879L16.5982 26.163C17.0685 25.2203 18.009 24.669 19.0688 24.7253C20.1218 24.7815 21.0037 25.4272 21.3727 26.4128L25.7355 38.0452C25.803 38.2275 25.9447 38.2725 26.0505 38.277C26.172 38.2837 26.3025 38.2545 26.388 38.0812L28.746 33.3652C29.322 32.2155 30.4785 31.5 31.7655 31.5H41.625C42.246 31.5 42.75 32.004 42.75 32.625C42.75 33.246 42.246 33.75 41.625 33.75H31.7655C31.3358 33.75 30.951 33.9885 30.7597 34.371L28.4018 39.087C27.9517 39.9847 27.0697 40.5293 26.0775 40.5293C26.0303 40.5293 25.9807 40.5293 25.9335 40.5247C24.8805 40.4685 23.9985 39.8228 23.6295 38.8372L19.2668 27.2048C19.1992 27.0225 19.0575 26.9775 18.9518 26.973C18.8415 26.9842 18.6997 26.9977 18.6143 27.1687L16.2563 31.8847C15.6803 33.0345 14.5215 33.75 13.2345 33.75ZM49.5 22.4662V43.875C49.5 49.4572 44.9572 54 39.375 54H14.625C9.04275 54 4.5 49.4572 4.5 43.875V39.375C4.5 38.754 5.004 38.25 5.625 38.25C6.246 38.25 6.75 38.754 6.75 39.375V43.875C6.75 48.2175 10.2825 51.75 14.625 51.75H39.375C43.7175 51.75 47.25 48.2175 47.25 43.875V22.4662C47.25 21.7125 47.1645 20.9745 47.034 20.25H34.875C31.7745 20.25 29.25 17.7255 29.25 14.625V2.466C28.5233 2.3355 27.7853 2.25 27.0338 2.25H14.625C10.2825 2.25 6.75 5.7825 6.75 10.125V25.875C6.75 26.496 6.246 27 5.625 27C5.004 27 4.5 26.496 4.5 25.875V10.125C4.5 4.54275 9.04275 0 14.625 0H27.0338C30.9398 0 34.614 1.521 37.3747 4.284L45.216 12.1252C47.979 14.8883 49.5 18.5602 49.5 22.4662ZM46.3973 18C45.783 16.416 44.8627 14.9535 43.6275 13.716L35.7863 5.87475C34.5487 4.63725 33.0863 3.717 31.5023 3.105V14.6272C31.5023 16.488 33.0165 18.0023 34.8773 18.0023H46.3995L46.3973 18Z",
    fill: "#0073FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3477_17734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcareIcon);
export default __webpack_public_path__ + "static/media/healthcare-icon.75f37e6b3badcb2627a66b0a01cc54ff.svg";
export { ForwardRef as ReactComponent };